module.exports = __webpack_public_path__ + "static/why_aion_waves-75caa95dfb7d35bcd338a61fcb0ba92a.svg";